"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZones = exports.defaultZoneData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultZoneData = exports.defaultZoneData = {
  id: null,
  name: ''
};
const getZones = params => (0, _request.default)({
  url: '/zones',
  method: 'get',
  params
});
exports.getZones = getZones;